import { action, observable, reaction } from "mobx";
import { RootController } from "./root.controller";

export const makeCategoriesController = () => {
  const s = observable({
    ROOT: null as RootController | null,
    get categories() {
      return s.ROOT?.LOCALDB.data.categories;
    },
    reset: () => {
    },
    getAllCategories: async () => {
      await s.ROOT?.API.getMany('/api/categories', 'categories');
    },
    init: action((root: RootController) => {
      s.ROOT = root;
      reaction(
        () => s.ROOT?.AUTH.isAuthenticated,
        isAuthenticated => isAuthenticated && s.getAllCategories(),
        { fireImmediately: true }
      )
    })
  })
  return s;

}

export type CategoriesController = ReturnType<typeof makeCategoriesController>;
